module.exports = __webpack_public_path__ + "img/x.349538fa.svg";